<template>
  <header id="header">

    <b-navbar toggleable="md" type="dark">

      <b-navbar-brand href="#"><h1>OurQualityCare</h1></b-navbar-brand>

      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

      <b-collapse is-nav id="nav_collapse">

        <b-navbar-nav class="ml-auto">
          <template v-for="(section, index) in sections">
            <b-nav-item :key="section.name+index" :href="'#' + section.link" v-scroll-to="{
              el: '#' + section.link,
              offset: elOffset(section.link)
            }" v-if="index === 0">{{ section.name }}</b-nav-item>
            <b-nav-item :key="section.name+index" :href="'#' + section.link" v-scroll-to="{
              el: '#' + section.link,
              offset: elOffset(section.link)
            }" v-else>{{ section.name }}</b-nav-item>
          </template>
          <template v-for="(item, i) in social">
            <b-nav-item :key="item.title+i" :href="item.url" :target="'_blank'" :class="item.class + ' icon social'">{{ item.title }}</b-nav-item>
          </template>
        </b-navbar-nav>

      </b-collapse>

    </b-navbar>
  </header>
</template>

<script>
/* eslint-disable */
export default {
  name: 'Header',
  data () {
    return {
      sections: this.content.navigation,
      social: this.content.footerNav
    }
  },
  methods: {
    elOffset: function(el) {
      if ($(window).width() > 576) {
        if (el == 'quality') {
          return -50;
        } else if (el == 'commitment') {
          return -50;
        } else {
          return -50;
        }
      } else {
        if ($('header#header').hasClass('sticky')) {
          if (el == 'quality') {
            return -200;
          } else if (el == 'commitment') {
            return -300;
          } else {
            return -200;
          }
        } else {
          console.log('here');
          if (el == 'quality') {
            return -350;
          } else if (el == 'commitment') {
            return -450;
          } else {
            return -350;
          }
        }
      }
    }
  }
}

$(document).ready(function() {
  stickyHeader();

  $(window).resize(function() {
    stickyHeader();
  });
});

function stickyHeader() {
  var nav = $("header#header");
  var sticky = "sticky";
  var hero = $("#hero").height();

  $(window).scroll(function() {
    if( $(this).scrollTop() > hero ) {
      if ($(window).width > 576) {
        nav.addClass(sticky);
        $("#app > .container-fluid").css('padding-bottom', nav.height() + 32);
      } else {
        nav.addClass(sticky);
        $("#app > .container-fluid").css('padding-bottom', nav.height() + 32);
      }
    } else {
      nav.removeClass(sticky);
      $("#app > .container-fluid").css('padding-bottom', '0');
    }
  });
}
</script>

<style lang="scss">
@import '../_variables.scss';

#header {
  width: 100%;
  margin-bottom: 2rem;
  position: static;
  &.sticky {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    margin-left: 1rem;
    margin-right: 1rem;
  }
  .social {
    &.icon {
      text-indent: -9999px;
      box-sizing: border-box;
      margin: 0 5px;
      display: none;
      @media (min-width: 768px) {
        display: inline-block;
      }
      &.facebook {
        a {
          background: url(../../static/facebook.svg) no-repeat;
          background-size: 90%;
          background-position: 2px 2px;
          transition: all .3s ease;
          cursor: pointer;
          &:hover {
            background-size: 100%;
            background-position: 0 0;
          }
        }
      }
      &.twitter {
        a {
          background: url(../../static/twitter.svg) no-repeat;
          background-size: 90%;
          background-position: 2px 2px;
          transition: all .3s ease;
          cursor: pointer;
          &:hover {
            background-size: 100%;
            background-position: 0 0;
          }
        }
      }
      &.linkedin {
        a {
          background: url(../../static/linkedin.svg) no-repeat;
          background-size: 90%;
          background-position: 2px 2px;
          transition: all .3s ease;
          cursor: pointer;
          &:hover {
            background-size: 100%;
            background-position: 0 0;
          }
        }
      }
      a {
        height: 35px;
        width: 35px;
        margin-top: 2px;
      }
    }
  }
}
.navbar {
  background: $black;
  h1 {
    font-size: 24px;
    margin: 0;
  }
  .navbar-toggler {
    border: none;
    padding: 0 auto;
    height: 44px;
  }
  &.navbar-dark {
    .navbar-toggler-icon {
      // background: url(../../static/nav.svg) no-repeat;
      background: none;
      width: 40px;
      height: 3px;
      background: $white;
      position: relative;
      // background-size: 100%;
      // transform: rotate(45deg);
      transition-delay: 0.12s;
      transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
      &:focus {
        border: none;
        outline-color: transparent;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        -webkit-appearance: none;
      }
      &:before,
      &:after {
        content: "";
        width: 40px;
        height: 3px;
        left: 0;
        background: $white;
        position: absolute;
      }
      &:before {
        top: -12px;
        // top: 0;
        opacity: 1;
        transition: top 0.075s ease, opacity 0.075s 0.12s ease;
      }
      &:after {
        bottom: -12px;
        // bottom: 0;
        // transform: rotate(-90deg);
        transition: bottom 0s ease, transform 0.075s 0.12s cubic-bezier(0.215, 0.61, 0.355, 1);
      }
    }
    .navbar-toggler[aria-expanded="true"] {
      .navbar-toggler-icon {
        transition-duration: 0.075s;
        transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
        transform: rotate(45deg);
        // transition-delay: 0.12s;
        &:before {
          opacity: 0;
          transition: top 0.075s 0.12s ease, opacity 0.075s ease;
        }
        &:after {
          transform: rotate(-90deg);
          bottom: 0;
          transition: bottom 0s 0.12s ease, transform 0.075s cubic-bezier(0.55, 0.055, 0.675, 0.19);
        }
      }
    }
    .navbar-nav {
      .nav-link {
        color: $white;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue